import React from "react";
import Select from "react-select";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { setPersonType } from "@parts/person/actions";

class IndividualOrCompanySelect extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      options: [
        {
          label: "Pessoa Física",
          value: 0,
        },
        {
          label: "Pessoa Jurídica",
          value: 1,
        },
      ],
    };
    this._onSelect = this._onSelect.bind(this);
  }

  _onSelect(item) {
    this.props.setPersonType(item.value);
  }

  UNSAFE_componentWillMount() {
    const { mei } = this.props;
    let { options } = this.state;
    if (mei) {
      options.push({ label: "MEI", value: 2 });
      this.setState({ ...this, options });
    }
    options.push({label: "Produtor Rural", value: 3})
  }

  render() {
    const { options } = this.state;
    const { type, loading } = this.props;

    return (
      <div className="py-2">
        Selecione o tipo
        <Select
          isDisabled={loading}
          onChange={this._onSelect}
          value={options[type || 0]}
          options={options}
        />
      </div>
    );
  }
}
const mapStateToProps = (state) => ({
  loading: state.loading,
  type: state.personType,
});

const mapDispatchToProps = (disptach) =>
  bindActionCreators({ setPersonType }, disptach);
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(IndividualOrCompanySelect);



// WEBPACK FOOTER //
// ./src/components/parts/person/individualOrCopanySelect/index.jsx